import React, { useState } from 'react'
import styled from 'styled-components'
import { LiveBlueIcon } from '../actions/edit'

import type { ActionHeader, ActionHeaderProps } from './index'

interface Props<Type> {
    title?: string
    editMode: boolean
    onEdit: () => void
    onChange: (form:Type) => void
    actionsHeader: ActionHeader<Type>[]
    collapseSettings?: { open: boolean; changeDirection: () => void }
    form: Type
}

interface ActionControllerProps<Type> {
    ActionComponent: React.FunctionComponent<ActionHeaderProps<Type>>
    form: Type
    onHide: () => void
    onChange: (form: Type) => void
}

function ActionController<Type>({ ActionComponent, form, onHide, onChange }: ActionControllerProps<Type>): JSX.Element {
    return (
        <div
            style={{
                height: 'calc(100% - 10px)',
                position: 'relative',
                flex: 1,
                padding: '5px'
            }}
        >
            <div
                style={{
                    height: '100%',
                    width: '100%',
                    position: 'absolute',

                    left: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                {ActionComponent ? <ActionComponent onChange={onChange} form={form} onHide={onHide} /> : null}
            </div>
        </div>
    )
}

export default function ComponentHeader<Type>({
    editMode,
    title,
    onEdit,
    onChange,
    actionsHeader = [],
    collapseSettings,
    form
}: Props<Type>): JSX.Element {
    const [actionPosition, setActionPosition] = useState<number>(-1)

    const getActionComponent = (): React.FunctionComponent<ActionHeaderProps<Type>> => {
        if (actionsHeader[actionPosition]) {
            return actionsHeader[actionPosition]?.actionComponent
        }

        return null
    }

    const onHide = () => {        
        setActionPosition(-1)
    }

    return (
        <Header editMode={editMode}>
            <label>{title}</label>
            <ActionController<Type>
                ActionComponent={getActionComponent()}
                onHide={onHide}
                onChange={onChange}
                form={form}
            ></ActionController>
            {actionsHeader.map(({ icone: Icone, iconeClass, hideOnDisplayMode = false }, index) => {
                const show = editMode || (!editMode && !hideOnDisplayMode)
                return (
                    show && (
                        <div key={`card_header_action_${index + 1}`} style={{ margin: '10px' }}>
                            {!Icone ? (
                                <LiveBlueIcon
                                    className={`far fa-${iconeClass}`}
                                    onClick={() => setActionPosition(actionPosition === index ? -1 : index)}
                                />
                            ) : (
                                <Icone form={form} onClick={() => setActionPosition(actionPosition === index ? -1 : index)}></Icone>
                            )}
                        </div>
                    )
                )
            })}
            {!editMode ? (
                <LiveBlueIcon className="far fa-edit" onClick={() => onEdit()} style={{ fontSize: '16px' }} />
            ) : null}
            {!editMode && collapseSettings ? (
                <LiveBlueIcon
                    className={`fas fa-chevron-${collapseSettings.open ? 'up' : 'down'}`}
                    onClick={() => collapseSettings.changeDirection()}
                    style={{ paddingLeft: '12px', fontSize: '16px' }}
                />
            ) : null}
        </Header>
    )
}

const Header = styled.div<{ editMode: boolean }>`
    height: 48px;
    width: 100%;
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    background-color: ${({ editMode }) => (editMode ? '#EEEEEE' : 'white')};
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    padding: 0 24px;
`

export { Header }
